import { Box, Button, Grid, IconButton, Menu, MenuItem, Tooltip, Typography } from "@mui/material";
import React, { useState } from "react";

import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import { WSIcons } from "../../../commonFunctions/iIcons";
import WSSCheckBoxField from "../../../Components/CheckBox/WSCheckBox";
import WSDateField from "../../../Components/DateField/WSDateField";
import { ReservationSearch } from "./ReservationSearch";


export const ReservationList: React.FC<any> = React.memo((props) => {
  const { register, control } = useForm();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [cartOpen, setCartOpen] = useState(false);

  const handleCartClick = () => {
      setCartOpen(true);
  };
  
  const handleCartClose = () => {
      setCartOpen(false);
  };
  const handleClick = (path: string) => {
    navigate(path);
  };

  const columns: IColumns[] = [
    {
      header: "Res.#",
      fieldName: "workLocationName",
      tooltip: true,
    },
    {
      header: "Table",
      fieldName: "address",
      tooltip: true,
    },
    {
      header: "Time",
      fieldName: "address",
      tooltip: true,
    },
    {
      header: "Guset name",
      fieldName: "address",
      tooltip: true,
    },
    {
      header: "Adults",
      fieldName: "address",
      tooltip: true,
    },
    {
      header: "Child",
      fieldName: "address",
      tooltip: true,
    },
    {
        header: "Status",
        fieldName: "address",
        tooltip: true,
    },
    {
        header: "Remaining Time",
        fieldName: "address",
        tooltip: true,
    },
    {
        header: "Remarks",
        fieldName: "address",
        tooltip: true,
      },
  ];
  const handleMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  return (
    <Grid 
      display="flex" 
      flexDirection="column" 
      minHeight="100vh" // Ensures the container occupies the full height of the viewport
    >
    <Grid container direction="column" spacing={2} p={2} flex="1">
      {/* Header and Icon Section */}
      <Grid item>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", color: "green" }}
            >
              Reservation List
            </Typography>
          </Grid>
          <Grid item>
            <Grid display="flex" alignItems="center">
              
              <Grid display="flex" alignItems="center">
              {/* Order Filter IconButton with Dropdown */}
              <Tooltip title="Order Filter">
                <IconButton
                  sx={{
                    border: "1px solid #ccc",
                    padding: "8px",
                    marginRight: "8px",
                    borderRadius: "2px",
                  }}
                  onClick={handleMenuClick}
                >
                  <WSIcons.FilterAltIcon />
                </IconButton>
              </Tooltip>

              {/* Dropdown Menu */}
              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleMenuClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
              >
                <MenuItem > <WSSCheckBoxField
                        id="reserved"
                        {...register('reserved')}
                        label="Reserved"
                        control={control}
                        rules={{ required: true }}
                        defaultValue={false}
                    /></MenuItem>
                <MenuItem > <WSSCheckBoxField
                        id="walkins"
                        {...register('walkins')}
                        label="Walk Ins"
                        control={control}
                        rules={{ required: true }}
                        defaultValue={false}
                    /></MenuItem>
                <MenuItem > <WSSCheckBoxField
                        id="walkouts"
                        {...register('walkouts')}
                        label="Walk Outs"
                        control={control}
                        rules={{ required: true }}
                        defaultValue={false}
                    /></MenuItem>
                    <MenuItem > <WSSCheckBoxField
                        id="noshows"
                        {...register('noshows')}
                        label="No Shows"
                        control={control}
                        rules={{ required: true }}
                        defaultValue={false}
                    /></MenuItem>
                    <MenuItem > <WSSCheckBoxField
                        id="paused"
                        {...register('paused')}
                        label="Paused"
                        control={control}
                        rules={{ required: true }}
                        defaultValue={false}
                    /></MenuItem>
                     <MenuItem > <WSSCheckBoxField
                        id="voided"
                        {...register('voided')}
                        label="Voided"
                        control={control}
                        rules={{ required: true }}
                        defaultValue={false}
                    /></MenuItem>
              </Menu>
              </Grid>
              <Tooltip title="My Order">
                <IconButton
                  sx={{
                    border: "1px solid #ccc",
                    padding: "8px",
                    marginRight: "8px",
                    borderRadius: "2px",
                  }}
                >
                  <WSIcons.Person />
                </IconButton>
              </Tooltip>
              <Tooltip title="All Order">
                <IconButton
                  sx={{
                    border: "1px solid #ccc",
                    padding: "8px",
                    marginRight: "8px",
                    borderRadius: "2px",
                  }}
                >
                  <WSIcons.Groups2Icon />
                </IconButton>
              </Tooltip>
              <WSDateField
                id="date"
                name="date"
                dateFormat="D/MM/YYYY"
                control={control}
                defaultValue={null}
                rules={{ required: true }}
                label={""}
              />
              <Tooltip title="Refersh">
                <IconButton
                  sx={{
                    border: "1px solid #ccc",
                    padding: "8px",
                    marginRight: "8px",
                    borderRadius: "2px",
                    marginLeft: "16px",
                  }}
                >
                  <WSIcons.SyncIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Search">
                <IconButton
                  sx={{
                    border: "1px solid #ccc",
                    padding: "8px",
                    marginRight: "8px",
                    borderRadius: "2px",
                  }}
                  onClick={handleCartClick}
                >
                  <WSIcons.SearchIcon />
                </IconButton>
              </Tooltip>
              <ReservationSearch open={cartOpen} onClose={handleCartClose} />

              <IconButton>
                <WSIcons.CloseIcon
                  sx={{ backgroundColor: "red", color: "white" }}
                  onClick={() => handleClick("/")}
                />
              </IconButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* DataGrid Section */}
      <Grid item>
        <WSDataGrid id="itemGrid" title="" columns={columns} />
      </Grid>
      </Grid>
      <Grid
        bgcolor="#333"
        p={2}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <WSIcons.GTranslateIcon sx={{ color: "white" }} />
        <Grid display="flex" ml="auto" gap={4}>
          <Button
            variant="outlined"
            sx={{ borderColor: "green", color: "white" }}
          >
            Print List
          </Button>
          <Button
            variant="outlined"
            sx={{ borderColor: "green", color: "white" }}
          >
           Edit
          </Button>
          <Button variant="outlined"  sx={{ borderColor: "green", color: "white" }} onClick={() => handleClick("/tableview")}>
            New
          </Button>
          <Button
            variant="outlined"
            sx={{ borderColor: "green", color: "white" }}
            onClick={() => handleClick("/tableview")}
          >
            Table View
          </Button>
          <Button
            variant="contained"
            color="success" 
          >
            Select Operation
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
});
